import React from 'react';
import { NavLink } from 'react-router-dom';
import './navitem.css';

const NavItem = (props) => {
    return ( <>
    <NavLink
            className={({ isActive }) => 
                isActive ? `headerNavItemActive link` : `headerNavItem link`
            }
            to={props.navitemLocation}
        >
            {props.navitem}
        </NavLink>
    </> );
}
 
export default NavItem;